import { render, staticRenderFns } from "./ProjectStage.vue?vue&type=template&id=0efcf424&scoped=true"
import script from "./ProjectStage.vue?vue&type=script&lang=js"
export * from "./ProjectStage.vue?vue&type=script&lang=js"
import style0 from "./ProjectStage.vue?vue&type=style&index=0&id=0efcf424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcf424",
  null
  
)

export default component.exports